import React from 'react';
import { FormControl, TextField, InputAdornment, Icons } from '~/lib/bn-material-ui';
import { useBnMUIVariants } from '~/utility/styles/bn-mui-variants';

export function BnSearchField({ value, onChange, placeholder = 'Search', className }) {
  const bnMuiVariants = useBnMUIVariants();
  return (
    <FormControl margin='normal' className={className}>
      <TextField
        type='text'
        size='small'
        className={bnMuiVariants.outlinedSearchField}
        placeholder={placeholder}
        variant='outlined'
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-describedby='search-text'
        InputProps={{
          endAdornment: (
            <InputAdornment position='start'>
              <Icons.Search />
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
}
